import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePageTracking from "../../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../../redux/slices/trackActivitySlice";
import { getJobDetail, nurseProfile } from "../../../../redux/slices/jobsSlice";
import { Form, Button, Card, Row, Col, Spinner } from "react-bootstrap";
import { FiArrowLeft } from "react-icons/fi";
import Edit from "../../../../assets/images/edit-icon.svg";
import Img from "../../../../assets/images/user-profile.png";

import DatePicker from "react-datepicker";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../../../../components/toasts/index";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
// import LicenseTypeModal from "../../profile/Modals/licenseTypeModal";
import "./ApplyJob.scss";
import { applyJob } from "../../../../redux/slices/jobsSlice";
import {
  getViewProfile,
  updateProfile,
} from "../../../../redux/slices/profileSlice";
import EditProfileModal from "../../../profile/EditProfileModal";
import LicenseTypeModal from "../../../profile/Modals/licenseTypeModal";
import LicenseNumberModal from "../../../profile/Modals/licenseNumberModal";
import LicenseVerifiedModal from "../../../profile/Modals/LicenseVerifiedModal";
import YearsExperienceModal from "../../../profile/Modals/YearsExperienceModal";
import PrimarySpecialtyModal from "../../../profile/Modals/primarySpecialtyModal";
import AvailableToStartModal from "../../../profile/Modals/availableToStartModal";
import EducationModal from "../../../profile/Modals/educationModal";
import BedsideLast12MonthsModal from "../../../profile/Modals/bedsideLast12MonthsModal";
import PatientPopulationModal from "../../../profile/Modals/patientPopulationModal";
import TraumaLevelExperienceModal from "../../../profile/Modals/traumaLevelExperienceModal";
import CertsUploadedModal from "../../../profile/Modals/certsUploadedModal";
import ResumeUploadedModal from "../../../profile/Modals/resumeUploadedModal";
import ResumeUrlModal from "../../../profile/Modals/resumeUrlModal";
import AvailabilitySetModal from "../../../profile/Modals/availabilitySetModal";
import PreferencesConfirmedModal from "../../../profile/Modals/preferencesConfirmedModal";
import PreferredStatesModal from "../../../profile/Modals/preferredStatesModal";
import AdditionalSpecialtiesModal from "../../../profile/Modals/additionalSpecialtiesModal";
import LicensedStatesModal from "../../../profile/Modals/licensedStatesModal";
import ShiftPreferencesModal from "../../../profile/Modals/shiftPreferencesModal";
import EmrSystemsModal from "../../../profile/Modals/emrSystemsModal";
import EmploymentTypeModal from "../../../profile/Modals/employmentModal";
import YearsOfExperienceModal from "../../../profile/Modals/YearsOfExperienceModal";
import RelocationModal from "../../../profile/Modals/willingToRelocateModal";
import CompactLicenseModal from "../../../profile/Modals/compactNursingLicenseModal";
import CertificateModal from "../../../profile/Modals/certificateModal";
import SalaryModal from "../../../profile/Modals/salaryModel";
import UploadCertificateModal from "./CertUploadModal";
import ResUploadModal from "./ResUploadModal";
import NoIndexSEO from "../../../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../../../utils/seoConfig";
const ApplyJob = () => {
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("JOB_APPLY");
  useEffect(() => {
    dispatch(activityStart({ page_name: "JOB_APPLY", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "JOB_APPLY" }));
  }, [dispatch]);
  const { nurseProfileItems, isLoading, JobDetail } = useSelector(
    (state) => state.jobResults,
  );
  const [interviewDates, setInterviewDates] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const defaultProfile = {
    name: "John Doe",
    email: "loremipsum@gmail.com",
    profileImage: Img,
  };
  useEffect(() => {
    if (id) {
      dispatch(getJobDetail(id));
    }
  }, [id, dispatch]);
  const [profile, setProfile] = useState(defaultProfile);
  const [warningMessage, setWarningMessage] = useState("");
  const [apiErrors, setApiErrors] = useState([]);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [videoError, setVideoError] = useState("");
  const [showSalaryModal, setShowSalaryModal] = useState(false); // add
  const [showExperienceModal, setShowExperienceModal] = useState(false); // add

  const [showWillingToRelocateModal, setShowWillingToRelocateModal] = useState(
    false,
  );
  const [
    showHasCompactNursingLicenseModal,
    setShowHasCompactNursingLicenseModal,
  ] = useState(false);
  const [
    showIsLicenseHasBeenVerifiedModal,
    setShowIsLicenseHasBeenVerifiedModal,
  ] = useState(false);
  const [certFiles, setCertFiles] = useState({});
  const [selectedCerts, setSelectedCerts] = useState([]);
  const [showPrimarySpecialtyModal, setShowPrimarySpecialtyModal] = useState(
    false,
  );
  const [showAvailableToStartModal, setShowAvailableToStartModal] = useState(
    false,
  );
  const [
    showTraumaLevelExperienceModal,
    setShowTraumaLevelExperienceModal,
  ] = useState(false);
  const [showCertsUploadedModal, setShowCertsUploadedModal] = useState(false);
  const [showResumeUrlModal, setShowResumeUrlModal] = useState(false);
  const [
    showPreferencesConfirmedModal,
    setShowPreferencesConfirmedModal,
  ] = useState(false);
  const [showResumeUploadedModal, setShowResumeUploadedModal] = useState(false);
  const [showAvailabilitySetModal, setShowAvailabilitySetModal] = useState(
    false,
  );
  const [showPreferredStatesModal, setShowPreferredStatesModal] = useState(
    false,
  );
  const [showShiftPreferencesModal, setShowShiftPreferencesModal] = useState(
    false,
  );
  const [showEmrSystemsModal, setShowEmrSystemsModal] = useState(false);
  const [
    showAdditionalSpecialtiesModal,
    setShowAdditionalSpecialtiesModal,
  ] = useState(false);
  const [showLicensedStatesModal, setShowLicensedStatesModal] = useState(false);

  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [showEmploymentModal, setShowEmploymentModal] = useState(false);
  const [showLicenseTypeModal, setShowLicenseTypeModal] = useState(false);
  const [showLicenseNumberModal, setShowLicenseNumberModal] = useState(false);
  const [showYearsExperienceModal, setShowYearsExperienceModal] = useState(
    false,
  );
  const [
    showNursingEducationLevelModal,
    setShowNursingEducationLevelModal,
  ] = useState(false);
  const [
    showBedsideLast12MonthsModal,
    setShowBedsideLast12MonthsModal,
  ] = useState(false);
  const [showPatientPopulationModal, setShowPatientPopulationModal] = useState(
    false,
  );
  const handleEditProfileClick = () => setShowEditProfileModal(true);
  // const handleModalSave = (updatedProfile) => {
  //   setProfile((prev) => ({ ...prev, ...updatedProfile }));
  //   setShowEditProfileModal(false);
  // };
  const handleModalSave = (updatedProfile) => {
    setProfile((prev) => ({ ...prev, ...updatedProfile }));

    setFormData((prev) => ({
      ...prev,
      basic_info: {
        ...prev.basic_info,
        first_name: updatedProfile.name?.split(" ")[0] || "",
        last_name: updatedProfile.name?.split(" ")[1] || "",
        email: updatedProfile.email,
        phone: updatedProfile.mobile,
      },
    }));
  };

  const [formData, setFormData] = useState({
    basic_info: {
      id: "",
      first_name: "",
      last_name: "",
      full_name: "",
      email: "",
      phone: "",
      country_code: "",
      dob: "",
      profile_photo_path: "",
      profile_completed_percentage: "",
    },
    location_info: {
      current_city: "",
      current_state: "",
      work_city: "",
      work_state: "",
      address: "",
      zip_code: "",
      interested_states: [],
    },
    professional_info: {
      current_role: "",
      nursing_experience: "",
      career_objectives: [],
      location_choices: [],
    },
    nurse_profile: {
      current_city: "",
      current_state: "",
      willing_to_relocate: "",
      license_type: "",
      has_compact_license: false,
      license_number: "",
      license_verified: false,
      years_experience: "",
      primary_specialty: "",
      education: "",
      available_to_start: "",
      bedside_last_12mo: false,
      patient_population: "",
      trauma_level_exp: "",
      certs_uploaded: false,
      resume_uploaded: false,
      resume_url: "",
      availability_set: false,
      preferences_confirmed: false,
    },
    preferences: {
      preferred_states: [],
      licensed_states: [],
      certifications: [],
      additional_specialties: [],
      employment_types: [],
      shift_preferences: [],
      emr_systems: [],
      resume: [],
    },
    documents: {
      resume: [],
      license: [],
      certification: [],
      other: [],
      // introduction_video: null,
      introduction_video: [],
    },
    salary_preferences: {
      preferred_salary: "",
      median_annual_salary: "",
      annual_mortgage_payment_or_rent: "",
    },
  });
  useEffect(() => {
    setProfile({
      name: `${formData.basic_info.first_name} ${formData.basic_info.last_name}`.trim(),
      email: formData.basic_info.email,
      mobile: formData.basic_info.phone, // 🔥 THIS WAS MISSING
    });
  }, [formData.basic_info]);
  useEffect(() => {
    dispatch(getViewProfile());
  }, [dispatch]);

  // Helper function to safely parse data that might be a string or already parsed
  const safeParse = (data) => {
    if (!data) return [];
    if (typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.error("Failed to parse data:", e);
        return [];
      }
    }
    return Array.isArray(data) ? data : [];
  };
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isBasicInfoOpen, setIsBasicInfoOpen] = useState(false);
  const [isNurseProfileOpen, setIsNurseProfileOpen] = useState(false);
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  const [isScheduleInterviewOpen, setIsScheduleInterviewOpen] = useState(false);
  const [isIntroVideoOpen, setIsIntroVideoOpen] = useState(false);
  const [isDocumentsOpen, setIsDocumentsOpen] = useState(false);

  // Track manual interactions
  const [isBasicInfoManuallyToggled, setIsBasicInfoManuallyToggled] = useState(
    false,
  );
  const [
    isNurseProfileManuallyToggled,
    setIsNurseProfileManuallyToggled,
  ] = useState(false);
  const [
    isPreferencesManuallyToggled,
    setIsPreferencesManuallyToggled,
  ] = useState(false);

  // Check for empty fields and auto-open sections
  useEffect(() => {
    if (nurseProfileItems && Object.keys(nurseProfileItems).length > 0) {
      // Check Basic Information
      const isBasicInfoEmpty =
        !formData.basic_info.first_name ||
        !formData.basic_info.last_name ||
        !formData.basic_info.phone;

      // Check Nurse Profile
      const isNurseProfileEmpty =
        !formData.nurse_profile.license_type ||
        formData.nurse_profile.has_compact_license === null ||
        formData.nurse_profile.has_compact_license === undefined ||
        !formData.nurse_profile.nursing_experience ||
        !formData.nurse_profile.primary_specialty ||
        !formData.nurse_profile.education ||
        !formData.nurse_profile.available_to_start ||
        formData.nurse_profile.bedside_last_12mo === null ||
        formData.nurse_profile.bedside_last_12mo === undefined ||
        !formData.nurse_profile.willing_to_relocate;

      // Check Preferences
      const isPreferencesEmpty =
        !formData.preferences.licensed_states?.length ||
        !formData.preferences.certifications?.length ||
        !formData.nurse_profile.license_number ||
        !formData.preferences.shift_preferences?.length ||
        !formData.documents.resume?.length ||
        !formData.preferences.employment_types?.length;

      // Only auto-open/close if user hasn't manually toggled
      if (!isBasicInfoManuallyToggled) {
        setIsBasicInfoOpen(isBasicInfoEmpty);
      }
      if (!isNurseProfileManuallyToggled) {
        setIsNurseProfileOpen(isNurseProfileEmpty);
      }
      if (!isPreferencesManuallyToggled) {
        setIsPreferencesOpen(isPreferencesEmpty);
      }
    }
  }, [
    formData,
    nurseProfileItems,
    isBasicInfoManuallyToggled,
    isNurseProfileManuallyToggled,
    isPreferencesManuallyToggled,
  ]);

  useEffect(() => {
    if (id) {
      dispatch(nurseProfile({ job_id: id }));
    }
  }, [dispatch, id]);
  const [nursingExperience, setNursingExperience] = useState({
    value: "Nursing Student",
    isEditing: false,
  });

  useEffect(() => {
    if (nurseProfileItems && Object.keys(nurseProfileItems).length > 0) {
      setFormData({
        basic_info: {
          id: nurseProfileItems?.basic_info?.id || "",
          first_name: nurseProfileItems?.basic_info?.first_name || "",
          last_name: nurseProfileItems?.basic_info?.last_name || "",
          full_name: nurseProfileItems?.basic_info?.full_name || "",
          email: nurseProfileItems?.basic_info?.email || "",
          phone: nurseProfileItems?.basic_info?.phone || "",
          country_code: nurseProfileItems?.basic_info?.country_code || "",
          dob: nurseProfileItems?.basic_info?.dob || "",
          profile_photo_path:
            nurseProfileItems?.basic_info?.profile_photo_path || "",
          profile_completed_percentage:
            nurseProfileItems?.basic_info?.profile_completed_percentage || "",
        },
        location_info: {
          current_city: nurseProfileItems?.location_info?.current_city || "",
          current_state: nurseProfileItems?.location_info?.current_state || "",
          work_city: nurseProfileItems?.location_info?.work_city || "",
          work_state: nurseProfileItems?.location_info?.work_state || "",
          address: nurseProfileItems?.location_info?.address || "",
          zip_code: nurseProfileItems?.location_info?.zip_code || "",
          interested_states: safeParse(
            nurseProfileItems?.location_info?.interested_states,
          ),
        },
        professional_info: {
          current_role:
            nurseProfileItems?.professional_info?.current_role?.title || "",
          nursing_experience:
            nurseProfileItems?.professional_info?.nursing_experience?.title ||
            "",
          career_objectives: safeParse(
            nurseProfileItems?.professional_info?.career_objectives,
          ),
          location_choices: safeParse(
            nurseProfileItems?.professional_info?.location_choices,
          ),
        },
        nurse_profile: {
          current_city: nurseProfileItems?.nurse_profile?.current_city || "",
          current_state: nurseProfileItems?.nurse_profile?.current_state || "",
          willing_to_relocate:
            nurseProfileItems?.nurse_profile?.willing_to_relocate || "",
          license_type: nurseProfileItems?.nurse_profile?.license_type || "",
          has_compact_license:
            nurseProfileItems?.nurse_profile?.has_compact_license || false,
          license_number:
            nurseProfileItems?.nurse_profile?.license_number || "",
          license_verified:
            nurseProfileItems?.nurse_profile?.license_verified || false,
          years_experience:
            nurseProfileItems?.nurse_profile?.years_experience || "",
          primary_specialty:
            nurseProfileItems?.nurse_profile?.primary_specialty || "",
          education: nurseProfileItems?.nurse_profile?.education || "",
          available_to_start:
            nurseProfileItems?.nurse_profile?.available_to_start || "",
          bedside_last_12mo:
            nurseProfileItems?.nurse_profile?.bedside_last_12mo || false,
          patient_population:
            nurseProfileItems?.nurse_profile?.patient_population || "",
          trauma_level_exp:
            nurseProfileItems?.nurse_profile?.trauma_level_exp || "",
          certs_uploaded:
            nurseProfileItems?.nurse_profile?.certs_uploaded || false,
          // resume_uploaded:
          //   nurseProfileItems?.nurse_profile?.resume_uploaded || false,
          resume_uploaded:
            nurseProfileItems?.documents?.resume?.length > 0
              ? true
              : nurseProfileItems?.nurse_profile?.resume_uploaded || false,
          resume_url: nurseProfileItems?.nurse_profile?.resume_url || "",
          availability_set:
            nurseProfileItems?.nurse_profile?.availability_set || false,
          preferences_confirmed:
            nurseProfileItems?.nurse_profile?.preferences_confirmed || false,
          nursing_experience:
            nurseProfileItems?.nurse_profile?.nursing_experience || null,
        },
        // nurse_profile: {
        //   current_city: nurseProfileItems?.nurse_profile?.current_city || "",
        //   current_state: nurseProfileItems?.nurse_profile?.current_state || "",
        //   willing_to_relocate:
        //     nurseProfileItems?.nurse_profile?.willing_to_relocate || "",
        //   license_type: nurseProfileItems?.nurse_profile?.license_type || "",
        //   has_compact_license:
        //     nurseProfileItems?.nurse_profile?.has_compact_license || false,
        //   license_number:
        //     nurseProfileItems?.nurse_profile?.license_number || "",
        //   license_verified:
        //     nurseProfileItems?.nurse_profile?.license_verified || false,

        //   nursing_experience:
        //     nurseProfileItems?.nurse_profile?.nursing_experience || null,

        //   primary_specialty:
        //     nurseProfileItems?.nurse_profile?.primary_specialty || "",
        //   education: nurseProfileItems?.nurse_profile?.education || "",
        //   available_to_start:
        //     nurseProfileItems?.nurse_profile?.available_to_start || "",
        // },

        preferences: {
          preferred_states: safeParse(
            nurseProfileItems?.preferences?.preferred_states,
          ),
          licensed_states: safeParse(
            nurseProfileItems?.preferences?.licensed_states,
          ),
          certifications: safeParse(
            nurseProfileItems?.preferences?.certifications,
          ),
          resume: safeParse(nurseProfileItems?.preferences?.resume),
          additional_specialties: safeParse(
            nurseProfileItems?.preferences?.additional_specialties,
          ),
          employment_types: safeParse(
            nurseProfileItems?.preferences?.employment_types,
          ),
          shift_preferences: safeParse(
            nurseProfileItems?.preferences?.shift_preferences,
          ),
          emr_systems: safeParse(nurseProfileItems?.preferences?.emr_systems),
        },
        documents: {
          resume: safeParse(nurseProfileItems?.documents?.resume),
          license: safeParse(nurseProfileItems?.documents?.license),
          certification: safeParse(nurseProfileItems?.documents?.certification),
          other: safeParse(nurseProfileItems?.documents?.other),
        },
        salary_preferences: {
          preferred_salary:
            nurseProfileItems?.salary_preferences?.preferred_salary || "",
          median_annual_salary:
            nurseProfileItems?.salary_preferences?.median_annual_salary || "",
          annual_mortgage_payment_or_rent:
            nurseProfileItems?.salary_preferences
              ?.annual_mortgage_payment_or_rent || "",
        },
      });
    }
  }, [nurseProfileItems]);

  // const handleInputChange = (section, field, value, files = null) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [section]: {
  //       ...prev[section],
  //       [field]: value,
  //       ...(files && field === "certifications"
  //         ? { certification_files: files }
  //         : {}),
  //     },
  //   }));
  //   setErrors((prev) => ({
  //     ...prev,
  //     [`${section}_${field}`]: "",
  //   }));
  // };
  const handleInputChange = (section, field, value, files = null) => {
    setFormData((prev) => {
      let updated = {
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      };

      // ✅ CERTIFICATIONS (already done)
      if (files && field === "certifications") {
        const certDocs = Object.keys(files).map((key) => ({
          name: key,
          original_filename: key,
          status: "uploaded",
          file: files[key],
        }));

        updated.documents = {
          ...prev.documents,
          certification: certDocs,
        };
      }
      if (section === "documents" && field === "resume") {
        const resumeDocs = (value || []).map((fileObj) => ({
          name: fileObj?.name || "Resume",
          original_filename: fileObj?.name || fileObj?.url || "Resume File",
          status: "uploaded",
          file: fileObj,
        }));

        updated.documents = {
          ...prev.documents,
          resume: resumeDocs,
        };

        // 🔥 IMPORTANT: SYNC FLAG
        updated.nurse_profile = {
          ...prev.nurse_profile,
          resume_uploaded: resumeDocs.length > 0,
        };
      }
      // 🔥 RESUME FIX
      // if (section === "documents" && field === "resume") {
      //   const resumeDocs = (value || []).map((fileObj) => ({
      //     name: fileObj?.name || "Resume",
      //     original_filename: fileObj?.name || fileObj?.url || "Resume File",
      //     status: "uploaded",
      //     file: fileObj,
      //   }));

      //   updated.documents = {
      //     ...prev.documents,
      //     resume: resumeDocs,
      //   };
      // }

      if (section === "documents" && field === "introduction_video") {
        const videoDocs = value
          ? [
              {
                name: value.name || "Introduction Video",
                original_filename: value.name,
                status: "uploaded",
                file: value,
              },
            ]
          : [];

        updated.documents = {
          ...prev.documents,
          introduction_video: videoDocs,
        };
      }

      return updated;
    });
  };
  const handleCheckboxChange = (section, field) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: !prev[section][field],
      },
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.basic_info.first_name.trim())
      newErrors.basic_info_first_name = "First name is required";
    if (!formData.basic_info.last_name.trim())
      newErrors.basic_info_last_name = "Last name is required";
    if (!formData.basic_info.email.trim()) {
      newErrors.basic_info_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.basic_info.email)) {
      newErrors.basic_info_email = "Enter a valid email";
    }
    if (!formData.basic_info.phone.trim())
      newErrors.basic_info_phone = "Phone is required";

    if (!formData.location_info.current_city.trim())
      newErrors.location_current_city = "Current city is required";
    if (!formData.location_info.current_state.trim())
      newErrors.location_current_state = "Current state is required";

    if (!formData.nurse_profile.license_number.trim())
      newErrors.nurse_license_number = "License number is required";
    if (!formData.nurse_profile.primary_specialty.trim())
      newErrors.nurse_primary_specialty = "Primary specialty is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const formatInterviewDate = (date) => {
    if (!date) return "";

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const formatInterviewDates = (dates) => {
    if (!dates || dates.length === 0) return [];
    return dates.map((date) => formatInterviewDate(date));
  };
  const handleSubmit = async (e) => {
    console.log("🔥 BUTTON CLICKED");
    e.preventDefault();

    // 🔥 Skip validation (since fields are mostly disabled)
    console.log("✅ SKIPPING VALIDATION");

    try {
      console.log("🚀 STEP 1: START SUBMIT");

      setIsSubmitting(true);

      const formattedInterviewDates = formatInterviewDates(interviewDates);
      console.log("📅 INTERVIEW DATES:", formattedInterviewDates);

      const formPayload = new FormData();

      // 🔹 Interview
      // formPayload.append("interview_date", selectedOption);

      // 🔹 Basic Info
      formPayload.append("first_name", formData.basic_info.first_name || "");
      formPayload.append("last_name", formData.basic_info.last_name || "");
      formPayload.append("email", formData.basic_info.email || "");
      formPayload.append("phone", formData.basic_info.phone || "");

      // 🔹 Location
      formPayload.append(
        "current_city",
        formData.location_info.current_city || "",
      );
      formPayload.append(
        "current_state",
        formData.location_info.current_state || "",
      );

      // 🔹 Nurse Profile
      formPayload.append(
        "license_type",
        formData.nurse_profile.license_type || "",
      );
      formPayload.append(
        "license_number",
        formData.nurse_profile.license_number || "",
      );
      formPayload.append(
        "primary_specialty",
        formData.nurse_profile.primary_specialty || "",
      );
      // formPayload.append(
      //   "years_experience",
      //   formData.nurse_profile.years_experience || "",
      // );
      formPayload.append("education", formData.nurse_profile.education || "");
      formPayload.append(
        "available_to_start",
        formData.nurse_profile.available_to_start || "",
      );

      formPayload.append(
        "willing_to_relocate",
        formData.nurse_profile.willing_to_relocate || "",
      );
      // formPayload.append("resume_url", formData.nurse_profile.resume_url || "");

      // 🔥 REQUIRED FIELD (IMPORTANT)
      formPayload.append(
        "nursing_experiences_id",
        formData.nurse_profile.nursing_experience?.id || "",
      );

      // 🔹 Boolean fields (TRUE/FALSE — NOT "1"/"0")
      formPayload.append(
        "has_compact_license",
        formData.nurse_profile.has_compact_license || false,
      );
      // formPayload.append(
      //   "license_verified",
      //   formData.nurse_profile.license_verified || false,
      // );
      formPayload.append(
        "bedside_last_12mo",
        formData.nurse_profile.bedside_last_12mo || false,
      );
      // formPayload.append(
      //   "certs_uploaded",
      //   formData.nurse_profile.certs_uploaded || false,
      // );
      formPayload.append(
        "resume_uploaded",
        formData.nurse_profile.resume_uploaded || false,
      );

      // 🔥 Arrays as JSON
      if (formData.preferences.certifications?.length > 0) {
        formPayload.append(
          "certifications",
          JSON.stringify(formData.preferences.certifications),
        );
      }

      // formData.preferences.additional_specialties?.forEach((item) => {
      //   formPayload.append("additional_specialties[]", item);
      // });
      if (formData.preferences.additional_specialties?.length > 0) {
        formPayload.append(
          "additional_specialties",
          JSON.stringify(formData.preferences.additional_specialties),
        );
      }

      if (formData.preferences.shift_preferences?.length > 0) {
        formPayload.append(
          "shift_preferences",
          JSON.stringify(formData.preferences.shift_preferences),
        );
      }

      if (formData.preferences.employment_types?.length > 0) {
        formPayload.append(
          "employment_types",
          JSON.stringify(formData.preferences.employment_types),
        );
      }

      // 🔹 Licensed States (as JSON array)
      if (formData.preferences.licensed_states?.length > 0) {
        formPayload.append(
          "licensed_states",
          JSON.stringify(formData.preferences.licensed_states),
        );
      }

      formData.preferences.emr_systems?.forEach((item) => {
        formPayload.append("emr_systems[]", item.system || item.name || item);
      });
      formData.preferences.preferred_states?.forEach((item) => {
        formPayload.append("preferred_states[]", item);
      });

      // 🔹 Interview Dates (Multiple dates as JSON)
      if (formattedInterviewDates.length > 0) {
        formPayload.append(
          "interview_dates",
          JSON.stringify(formattedInterviewDates),
        );
      }

      // 🔹 Optional Boolean fields
      // if (formData.nurse_profile.preferences_confirmed !== undefined) {
      //   formPayload.append(
      //     "preferences_confirmed",
      //     formData.nurse_profile.preferences_confirmed,
      //   );
      // }
      if (formData.nurse_profile.trauma_level_exp) {
        formPayload.append(
          "trauma_level_exp",
          formData.nurse_profile.trauma_level_exp,
        );
      }
      if (formData.nurse_profile.patient_population) {
        formPayload.append(
          "patient_population",
          formData.nurse_profile.patient_population,
        );
      }
      // // 🔹 Salary
      // formPayload.append(
      //   "preferred_salary",
      //   formData.salary_preferences.preferred_salary || "",
      // );

      // 🔹 Resume Upload
      if (formData.documents.resume?.length > 0) {
        formData.documents.resume.forEach((fileObj) => {
          if (fileObj.file) {
            formPayload.append("resume", fileObj.file);
          }
        });
      }
      // if (formData.documents.introduction_video) {
      //   formPayload.append(
      //     "introduction_video",
      //     formData.documents.introduction_video,
      //   );
      // }
      if (formData.documents.introduction_video?.length > 0) {
        const videoFile = formData.documents.introduction_video[0]?.file;

        if (videoFile) {
          formPayload.append("introduction_video", videoFile);
        }
      }

      // 🔍 DEBUG
      console.log("📦 FINAL FORMDATA:");
      for (let pair of formPayload.entries()) {
        console.log(pair[0], pair[1]);
      }

      // 🚀 API CALL
      console.log("🚀 DISPATCH START");

      const response = await dispatch(
        applyJob({
          job_id: id,
          data: formPayload,
        }),
      ).unwrap();

      console.log("✅ API RESPONSE:", response);

      // 🎯 HANDLE RESPONSE
      if (response?.success) {
        setApiErrors([]);

        // Check if there's a validation issue (not qualified)
        const hasValidation = response?.data?.qualified === false;

        console.log("🎉 SUCCESS - Has Validation:", hasValidation);

        // If there's validation, show the warning message on the page and toast
        if (hasValidation) {
          setWarningMessage(response.message);
          Toast.showWarning(response.message);
        } else {
          setWarningMessage("");
          Toast.showSuccess(response.message);
        }

        // Get application_url from JobDetail
        const applicationUrl = JobDetail?.application_url;

        // Show SweetAlert with redirect message and cancel button
        // Swal.fire({
        //   icon: "success",
        //   html: '<p style="margin: 0; padding: 0;">Your application submitted successfully. Now you are redirecting to employer site.</p>',
        //   timer: 3000,
        //   timerProgressBar: true,
        //   showCancelButton: true,
        //   confirmButtonText: 'Redirect Now',
        //   cancelButtonText: 'Cancel',
        //   allowOutsideClick: false,
        //   allowEscapeKey: false,
        //   buttonsStyling: true,
        //   confirmButtonColor: '#0195d3',
        //   cancelButtonColor: '#6c757d',
        //   customClass: {
        //     popup: "redirect-swal-modal",
        //   },
        // Get company name from JobDetail
        const companyName = JobDetail?.company?.name || "employer";

        Swal.fire({
          icon: "success",
          text: `Taking you to ${companyName}'s website to complete your application.`,
          timer: 3000,
          // timerProgressBar: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          // buttonsStyling: true,
          customClass: {
            popup: "success-popup-modal",
            timerProgressBar: "my-timer-bar",
          },
        }).then((result) => {
          // If user clicked cancel or timer ran out, check the result
          if (
            result.isConfirmed ||
            result.dismiss === Swal.DismissReason.timer
          ) {
            // Redirect to application_url
            if (applicationUrl) {
              const url = applicationUrl.startsWith("http")
                ? applicationUrl
                : `https://${applicationUrl}`;
              window.open(url, "_blank", "noopener,noreferrer");
            }

            // If NO validation errors, navigate back to job detail page after a short delay
            // This delay ensures the employer link opens before navigation
            if (!hasValidation) {
              setTimeout(() => {
                navigate(-1);
              }, 500);
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // User clicked cancel - don't redirect, just stay on page
            console.log("User cancelled redirection");

            // If NO validation errors, still navigate back to job detail page
            if (!hasValidation) {
              navigate(-1);
            }
          }
        });
      } else {
        console.log("❌ API FAILED");
        Toast.showError(response?.message || "Something went wrong");
      }
      // } catch (error) {
      //   console.log("❌ APPLY ERROR:", error);
      //   Toast.showError(error?.message || "Failed to submit application");
      // } finally {
    } catch (error) {
      console.log("❌ APPLY ERROR:", error);

      // 🔥 HANDLE BOTH CASES
      const errData = error?.response?.data || error;

      // ✅ CHECK VALIDATION ERROR
      if (errData?.status === 422 && errData?.data) {
        const messages = errData.data.map((err) => err.message);

        setApiErrors(messages);
        setWarningMessage("");

        return;
      }

      Toast.showError(errData?.message || "Failed to submit application");
    } finally {
      console.log("🔚 SUBMIT END");
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div
        className="apply-job-container d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="apply-job-container">
      <NoIndexSEO title={seoConfig.applyJob.title} />
      <div className="app-page-title">
        <div className="page-title-heading d-flex align-items-center">
          <FiArrowLeft
            size={40}
            className="icon cursor-pointer"
            onClick={() => navigate(`/job-detail/${id}`)}
          />
          {/* <h3 className="page-title">Complete Your Application</h3> */}
          <h3 className="page-title">Complete Your Work Profile </h3>
        </div>
      </div>
      <div className="apply-job-wrapper">
        <Card className="apply-job-form-card">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {/* Basic Information Section */}
              <div className="form-section mb-2">
                <h5
                  className="section-title d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsBasicInfoOpen(!isBasicInfoOpen);
                    setIsBasicInfoManuallyToggled(true);
                  }}
                >
                  <span>Basic Information</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isBasicInfoOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isBasicInfoOpen && (
                  <>
                    <Row>
                      <div className="col-md-6">
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            First Name <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={handleEditProfileClick}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input pe-5"
                              placeholder="Select first name"
                              type="text"
                              value={formData.basic_info.first_name}
                              disabled
                              style={{ pointerEvents: "none" }}
                              onChange={(e) =>
                                handleInputChange(
                                  "basic_info",
                                  "first_name",
                                  e.target.value,
                                )
                              }
                            />

                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>

                          {errors.basic_info_first_name && (
                            <div className="invalid-feedback">
                              {errors.basic_info_first_name}
                            </div>
                          )}
                        </Form.Group>
                      </div>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Last Name <span className="text-danger">*</span>
                          </Form.Label>
                          <div
                            className="position-relative"
                            onClick={handleEditProfileClick}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select last name"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.basic_info.last_name}
                              onChange={(e) =>
                                handleInputChange(
                                  "basic_info",
                                  "last_name",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={handleEditProfileClick}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                          {errors.basic_info_last_name && (
                            <div className="invalid-feedback">
                              {errors.basic_info_last_name}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <div className="col-md-6">
                        <Form.Group className="form-group mb-1">
                          <Form.Label className="col-label">
                            Mobile Number <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={handleEditProfileClick}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input pe-5"
                              placeholder="Select mobile number"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.basic_info.phone || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  "basic_info",
                                  "phone",
                                  e.target.value,
                                )
                              }
                            />

                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={handleEditProfileClick}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>

                          {errors.basic_info_phone && (
                            <div className="invalid-feedback d-block">
                              {errors.basic_info_phone}
                            </div>
                          )}
                        </Form.Group>
                      </div>
                    </Row>
                  </>
                )}
              </div>

              {/* Nurse Profile Section */}
              <div className="form-section mb-2">
                <h5
                  className="section-title d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsNurseProfileOpen(!isNurseProfileOpen);
                    setIsNurseProfileManuallyToggled(true);
                  }}
                >
                  <span>Nurse Profile</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isNurseProfileOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isNurseProfileOpen && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            License Type <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowLicenseTypeModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select license type"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.nurse_profile.license_type}
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "license_type",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowLicenseTypeModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group mb-1">
                          <Form.Label className="col-label">
                            Has compact nursing license
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowHasCompactNursingLicenseModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select has compact nursing license"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={
                                formData?.nurse_profile?.has_compact_license ===
                                true
                                  ? "Yes"
                                  : formData?.nurse_profile
                                      ?.has_compact_license === false
                                  ? "No"
                                  : ""
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() =>
                                setShowHasCompactNursingLicenseModal(true)
                              }
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Years of Experience{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowExperienceModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select years of experience"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={
                                formData?.nurse_profile?.nursing_experience
                                  ?.title ||
                                formData?.nurse_profile?.nursing_experience
                                  ?.name ||
                                ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "years_experience",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowExperienceModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Specialties <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            // onClick={setShowPrimarySpecialtyModal}
                            onClick={setShowAdditionalSpecialtiesModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select specialties"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.nurse_profile.primary_specialty}
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "primary_specialty",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              // onClick={() => setShowPrimarySpecialtyModal(true)}
                              onClick={() =>
                                setShowAdditionalSpecialtiesModal(true)
                              }
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                          {errors.nurse_primary_specialty && (
                            <div className="invalid-feedback">
                              {errors.nurse_primary_specialty}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Nursing education level
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowNursingEducationLevelModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select nursing education level
"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.nurse_profile.education}
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "education",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() =>
                                setShowNursingEducationLevelModal(true)
                              }
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Available to Start{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowAvailableToStartModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select available to start"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.nurse_profile.available_to_start}
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "available_to_start",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowAvailableToStartModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Bedside work in the last 12 months
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowBedsideLast12MonthsModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select bedside last 12 months"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={
                                formData?.nurse_profile?.bedside_last_12mo ===
                                true
                                  ? "Yes"
                                  : formData?.nurse_profile
                                      ?.bedside_last_12mo === false
                                  ? "No"
                                  : ""
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() =>
                                setShowBedsideLast12MonthsModal(true)
                              }
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Willing to Relocate{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowWillingToRelocateModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select willing to relocate"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              // value={formData.nurse_profile.willing_to_relocate}
                              value={
                                formData.nurse_profile.willing_to_relocate
                                  ? formData.nurse_profile.willing_to_relocate
                                      .charAt(0)
                                      .toUpperCase() +
                                    formData.nurse_profile.willing_to_relocate.slice(
                                      1,
                                    )
                                  : ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "willing_to_relocate",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() =>
                                setShowWillingToRelocateModal(true)
                              }
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </div>

              {/* Preferences Section */}
              <div className="form-section mb-2">
                <h5
                  className="section-title d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsPreferencesOpen(!isPreferencesOpen);
                    setIsPreferencesManuallyToggled(true);
                  }}
                >
                  <span>Preferences</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isPreferencesOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isPreferencesOpen && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Licensed States
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowLicensedStatesModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select licensed states"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.preferences.licensed_states.join(
                                ", ",
                              )}
                              onChange={(e) =>
                                handleInputChange(
                                  "preferences",
                                  "licensed_states",
                                  e.target.value
                                    .split(",")
                                    .map((s) => s.trim()),
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowLicensedStatesModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Preferred certificate
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowCertificateModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select preferred certificate"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              // value={formData.preferences.certifications.join(", ")}
                              value={formData.preferences.certifications
                                .map((item) =>
                                  typeof item === "string"
                                    ? item.toUpperCase()
                                    : (
                                        item?.name ||
                                        item?.title ||
                                        String(item)
                                      ).toUpperCase(),
                                )
                                .join(", ")}
                              onChange={(e) =>
                                handleInputChange(
                                  "preferences",
                                  "certifications",
                                  e.target.value
                                    .split(",")
                                    .map((s) => s.trim()),
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowCertificateModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* <Row>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label className="col-label">
                        Preferred States
                      </Form.Label>

                      <div
                        className="position-relative"
                        onClick={setShowPreferredStatesModal}
                        style={{ cursor: "pointer" }}
                      >
                        <Form.Control
                          className="col-input"
                          placeholder="Select preferred states"
                          type="text"
                          disabled
                          style={{ pointerEvents: "none" }}
                          value={formData.preferences.preferred_states.join(
                            ", ",
                          )}
                          onChange={(e) =>
                            handleInputChange(
                              "preferences",
                              "preferred_states",
                              e.target.value.split(",").map((s) => s.trim()),
                            )
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-link p-0 text-decoration-none position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                          onClick={() => setShowPreferredStatesModal(true)}
                        >
                          <img src={Edit} alt="Edit" width={14} />
                        </button>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label className="col-label">
                        Additional Specialties
                      </Form.Label>

                      <div
                        className="position-relative"
                        onClick={setShowAdditionalSpecialtiesModal}
                        style={{ cursor: "pointer" }}
                      >
                        <Form.Control
                          className="col-input"
                          placeholder="Select additional specialties"
                          type="text"
                          disabled
                          style={{ pointerEvents: "none" }}
                          value={formData.preferences.additional_specialties.join(
                            ", ",
                          )}
                          onChange={(e) =>
                            handleInputChange(
                              "preferences",
                              "additional_specialties",
                              e.target.value.split(",").map((s) => s.trim()),
                            )
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-link p-0 text-decoration-none position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                          onClick={() =>
                            setShowAdditionalSpecialtiesModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" width={14} />
                        </button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row> */}

                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            License Number{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowLicenseNumberModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select license number"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.nurse_profile.license_number}
                              onChange={(e) =>
                                handleInputChange(
                                  "nurse_profile",
                                  "license_number",
                                  e.target.value,
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowLicenseNumberModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                          {errors.nurse_license_number && (
                            <div className="invalid-feedback">
                              {errors.nurse_license_number}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Shift Preferences
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowShiftPreferencesModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select shift preferences"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.preferences.shift_preferences.join(
                                ", ",
                              )}
                              onChange={(e) =>
                                handleInputChange(
                                  "preferences",
                                  "shift_preferences",
                                  e.target.value
                                    .split(",")
                                    .map((s) => s.trim()),
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowShiftPreferencesModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group mb-1">
                          <Form.Label className="col-label">
                            Have you uploaded your resume?
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowResumeUploadedModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Have you uploaded your resume?"
                              type="text"
                              disabled
                              required
                              style={{ pointerEvents: "none" }}
                              value={
                                formData.nurse_profile.resume_uploaded === true
                                  ? `Yes${
                                      formData.documents.resume?.length > 0
                                        ? ` - ${formData.documents.resume
                                            .map((r) => r.original_filename)
                                            .join(", ")}`
                                        : ""
                                    }`
                                  : formData.nurse_profile.resume_uploaded ===
                                    false
                                  ? "No"
                                  : ""
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "preferences",
                                  "resume",
                                  e.target.value
                                    .split(",")
                                    .map((s) => s.trim()),
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowResumeUploadedModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                          {errors.documents_resume && (
                            <div className="invalid-feedback d-block">
                              {errors.documents_resume}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group">
                          <Form.Label className="col-label">
                            Preferred Employment Types
                          </Form.Label>

                          <div
                            className="position-relative"
                            onClick={setShowEmploymentModal}
                            style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              className="col-input"
                              placeholder="Select preferred employment types"
                              type="text"
                              disabled
                              style={{ pointerEvents: "none" }}
                              value={formData.preferences.employment_types.join(
                                ", ",
                              )}
                              onChange={(e) =>
                                handleInputChange(
                                  "preferences",
                                  "employment_types",
                                  e.target.value
                                    .split(",")
                                    .map((s) => s.trim()),
                                )
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none position-absolute"
                              style={{
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                              onClick={() => setShowEmploymentModal(true)}
                            >
                              <img src={Edit} alt="Edit" width={14} />
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                      {/* <Col md={6}>
                    <Form.Group className="form-group">
                      <Form.Label className="col-label">EMR Systems</Form.Label>

                      <div
                        className="position-relative"
                        onClick={setShowEmrSystemsModal}
                        style={{ cursor: "pointer" }}
                      >
                        <Form.Control
                          className="col-input"
                          placeholder="Select emr systems"
                          type="text"
                          disabled
                          style={{ pointerEvents: "none" }}
                          value={formData.preferences.emr_systems.join(", ")}
                          onChange={(e) =>
                            handleInputChange(
                              "preferences",
                              "emr_systems",
                              e.target.value.split(",").map((s) => s.trim()),
                            )
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-link p-0 text-decoration-none position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                          onClick={() => setShowEmrSystemsModal(true)}
                        >
                          <img src={Edit} alt="Edit" width={14} />
                        </button>
                      </div>
                    </Form.Group>
                  </Col> */}
                    </Row>
                  </>
                )}
              </div>

              {/* Interview Schedule Section */}
              <div className="form-section mb-2">
                <h5
                  className="section-title d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setIsScheduleInterviewOpen(!isScheduleInterviewOpen)
                  }
                >
                  <span>Schedule Interview</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isScheduleInterviewOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isScheduleInterviewOpen && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group mb-1">
                          <Form.Label className="col-label">
                            Select Interview Dates (Multiple)
                          </Form.Label>

                          <DatePicker
                            selected={null}
                            onChange={(date) => {
                              if (
                                date &&
                                !interviewDates.some(
                                  (d) => d.getTime() === date.getTime(),
                                )
                              ) {
                                setInterviewDates([...interviewDates, date]);
                              }
                            }}
                            dateFormat="MMMM d, yyyy"
                            className="col-input"
                            placeholderText="Click to add interview dates"
                            minDate={new Date()}
                            highlightDates={interviewDates}
                            popperPlacement="bottom-start"
                          />

                          {/* Display selected dates */}
                          {interviewDates.length > 0 && (
                            <div className="mt-3">
                              <small className="text-muted">
                                Selected Dates:
                              </small>
                              <div className="d-flex flex-wrap gap-2 mt-2">
                                {interviewDates.map((date, index) => (
                                  <div
                                    key={index}
                                    className="badge bg-primary d-flex align-items-center gap-2"
                                    style={{
                                      fontSize: "0.875rem",
                                      padding: "0.5rem 0.75rem",
                                    }}
                                  >
                                    <span>
                                      {date.toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                      })}
                                    </span>
                                    <button
                                      type="button"
                                      className="btn-close btn-close-white"
                                      style={{ fontSize: "0.6rem" }}
                                      onClick={() => {
                                        setInterviewDates(
                                          interviewDates.filter(
                                            (_, i) => i !== index,
                                          ),
                                        );
                                      }}
                                      aria-label="Remove date"
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
              <div className="form-section mb-3">
                <h5
                  className="section-title mb-3 d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsIntroVideoOpen(!isIntroVideoOpen)}
                >
                  <span>Introduction Video</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isIntroVideoOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isIntroVideoOpen && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="form-group mb-1">
                          {/* <Form.Label className="col-label">
                        Upload Introduction Video
                      </Form.Label> */}

                          {/* Description */}
                          <Form.Label className="col-label">
                            Optional introduction video (MP4, MOV, WebM, AVI -
                            max 100MB)
                          </Form.Label>

                          {/* Custom Styled Input */}
                          <div
                            className="position-relative"
                            // onClick={handleEditProfileClick}
                            // style={{ cursor: "pointer" }}
                          >
                            <Form.Control
                              type="file"
                              accept=".mp4,.mov,.webm,.avi"
                              className="col-input"
                              onChange={(e) => {
                                const file = e.target.files[0];

                                if (!file) return;

                                const allowedTypes = [
                                  "video/mp4",
                                  "video/quicktime",
                                  "video/webm",
                                  "video/x-msvideo",
                                ];

                                const allowedExtensions = [
                                  "mp4",
                                  "mov",
                                  "webm",
                                  "avi",
                                ];
                                const fileExtension = file.name
                                  .split(".")
                                  .pop()
                                  .toLowerCase();

                                // ❌ Invalid type
                                if (
                                  !allowedTypes.includes(file.type) ||
                                  !allowedExtensions.includes(fileExtension)
                                ) {
                                  const message =
                                    "Only MP4, MOV, WebM, AVI files are allowed";

                                  setVideoError(message); // 👈 show below input
                                  Toast.showError(message); // 👈 show toast
                                  e.target.value = "";
                                  return;
                                }

                                // ❌ Size check
                                if (file.size > 100 * 1024 * 1024) {
                                  const message =
                                    "File must be less than 100MB";

                                  setVideoError(message);
                                  Toast.showError(message);
                                  e.target.value = "";
                                  return;
                                }

                                // ✅ Success
                                setVideoError(""); // clear error
                                handleInputChange(
                                  "documents",
                                  "introduction_video",
                                  file,
                                );
                              }}
                            />
                          </div>

                          {/* File Name Preview */}
                          {/* {formData.documents.introduction_video && (
                        <div className="file-preview mt-2">
                          <span className="text-success">
                            {formData.documents.introduction_video.name}
                          </span>
                        </div>
                      )} */}
                        </Form.Group>
                        {videoError && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "13px" }}
                          >
                            {videoError}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </div>
              {/* Documents Section */}
              <div className="form-section mb-2">
                <h5
                  className="section-title d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsDocumentsOpen(!isDocumentsOpen)}
                >
                  <span>Documents</span>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform: isDocumentsOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M1 1.5L6 6.5L11 1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </h5>
                {isDocumentsOpen && (
                  <>
                    <div className="documents-subsection mb-3">
                      <h6 className="mb-2">Resume</h6>
                      {formData.documents.resume.length > 0 ? (
                        formData.documents.resume.map((doc, idx) => (
                          <div
                            key={idx}
                            className="document-item mb-2 p-2 rounded"
                          >
                            <h6>
                              <strong>{doc.name}</strong>
                            </h6>
                            <p className="">{doc.original_filename}</p>
                            <p className="mb-0">Status: {doc.status}</p>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No resume uploaded</p>
                      )}
                    </div>

                    <div className="documents-subsection mb-3">
                      <h6 className="mb-2">Certifications</h6>
                      {formData.documents.certification.length > 0 ? (
                        formData.documents.certification.map((doc, idx) => (
                          <div
                            key={idx}
                            className="document-item mb-2 p-2 rounded"
                          >
                            <p>
                              <p>
                                <strong>{doc.label || doc.name}</strong>
                              </p>
                            </p>
                            <p>{doc.original_filename}</p>
                            <p className="mb-0">Status: {doc.status}</p>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted">No certifications uploaded</p>
                      )}
                    </div>
                  </>
                )}
                {/* <div className="documents-subsection mb-3">
                  <h6 className="mb-2">Introduction Video</h6>

                  {formData.documents.introduction_video?.length > 0 ? (
                    formData.documents.introduction_video.map((doc, idx) => (
                      <div key={idx} className="document-item mb-2 p-2 rounded">
                        <p>
                          <strong>{doc.name}</strong>
                        </p>
                        <p className="mb-0">Status: {doc.status}</p>

                        {doc.file && (
                          <video width="200" controls className="mt-2">
                            <source src={URL.createObjectURL(doc.file)} />
                          </video>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No introduction video uploaded</p>
                  )}
                </div> */}
              </div>

              {/* Submit Button */}
              {warningMessage && (
                <div className="alert alert-warning mb-3">{warningMessage}</div>
              )}
              {apiErrors.length > 0 && (
                <div className="alert alert-danger mb-3">
                  <ul className="mb-0">
                    {apiErrors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="form-section mb-2">
                <h5 className="section-title">Disclaimer</h5>
                {/* Disclaimer Section */}
                <div className="actuarial-container">
                  <div className="formula-box">
                    <div className="formula-content">
                      <div className="title">Disclaimer:</div>
                      <p>
                        MapMyPay collects your information to build your nurse
                        profile and assist with placement at partner hospitals.
                        Your data is stored securely and will not be sold to
                        third parties. By submitting, you authorize MapMyPay to
                        contact you about relevant opportunities and share your
                        profile with partner hospitals for placement purposes.
                        Clicking "Apply at Employer Site" will redirect you to
                        the hospital's external website where you must complete
                        a separate application to be considered for employment.
                        MapMyPay is not the employer and does not make hiring
                        decisions. By submitting you agree to our{" "}
                        <a
                          href="https://mapmypay.com/privacy-policy/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary fw-semibold text-decoration-underline"
                        >
                          Privacy Policy
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary"
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Apply at Employer Site"
                  )}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <EditProfileModal
        show={showEditProfileModal}
        onHide={() => setShowEditProfileModal(false)}
        profileData={profile}
        onSave={handleModalSave}
        isApplyPage={true}
      />
      <LicenseTypeModal
        show={showLicenseTypeModal}
        value={formData.nurse_profile.license_type}
        onHide={() => setShowLicenseTypeModal(false)}
        onSuccess={() => dispatch(nurseProfile())}
        shouldUpdateProfile={!formData.nurse_profile.license_type}
        onSave={(value) =>
          handleInputChange("nurse_profile", "license_type", value)
        }
        isApplyPage={true}
      />
      <EmploymentTypeModal
        show={showEmploymentModal}
        onHide={() => setShowEmploymentModal(false)}
        value={formData.preferences.employment_types}
        isApplyPage={true}
        shouldUpdateProfile={
          !formData.preferences.employment_types ||
          formData.preferences.employment_types.length === 0
        }
        onSave={(value) =>
          handleInputChange("preferences", "employment_types", value)
        }
      />
      <EmrSystemsModal
        show={showEmrSystemsModal}
        onHide={() => setShowEmrSystemsModal(false)}
        value={formData.preferences.emr_systems}
        isApplyPage={true}
        shouldUpdateProfile={
          !formData.preferences.emr_systems ||
          formData.preferences.emr_systems.length === 0
        }
        onSave={(value) =>
          handleInputChange("preferences", "emr_systems", value)
        }
      />
      <ShiftPreferencesModal
        show={showShiftPreferencesModal}
        onHide={() => setShowShiftPreferencesModal(false)}
        value={formData.preferences.shift_preferences}
        isApplyPage={true}
        shouldUpdateProfile={
          !formData.preferences.shift_preferences ||
          formData.preferences.shift_preferences.length === 0
        }
        onSave={(value) =>
          handleInputChange("preferences", "shift_preferences", value)
        }
      />
      <UploadCertificateModal
        show={showCertificateModal}
        onHide={() => setShowCertificateModal(false)}
        value={formData.preferences.certifications}
        files={formData.preferences.certification_files}
        isApplyPage={true}
        userName={`${formData?.basic_info?.first_name || ""} ${formData
          ?.basic_info?.last_name || ""}`.trim()}
        applicationId={id}
        shouldUpdateProfile={
          !formData.preferences.certification_files ||
          Object.keys(formData.preferences.certification_files || {}).length ===
            0
        }
        selectedCertifications={selectedCerts}
        setSelectedCertifications={setSelectedCerts}
        onSave={(value, files) =>
          handleInputChange("preferences", "certifications", value, files)
        }
      />
      <LicensedStatesModal
        show={showLicensedStatesModal}
        onHide={() => setShowLicensedStatesModal(false)}
        value={formData.preferences.licensed_states}
        isApplyPage={true}
        shouldUpdateProfile={
          !formData.preferences.licensed_states ||
          formData.preferences.licensed_states.length === 0
        }
        onSave={(value) =>
          handleInputChange("preferences", "licensed_states", value)
        }
      />
      <AdditionalSpecialtiesModal
        show={showAdditionalSpecialtiesModal}
        onHide={() => setShowAdditionalSpecialtiesModal(false)}
        // value={formData.nurse_profile.primary_specialty}
        primaryValue={formData.nurse_profile.primary_specialty}
        additionalValue={formData.preferences.additional_specialties}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.primary_specialty}
        // onSave={(value) =>
        //   handleInputChange("nurse_profile", "primary_specialty", value)
        // }
        onSave={(data) => {
          handleInputChange(
            "nurse_profile",
            "primary_specialty",
            data.primary_specialty,
          );

          handleInputChange(
            "preferences",
            "additional_specialties",
            data.additional_specialties,
          );
        }}
        // onSave={(data) =>
        //   handleInputChange(
        //     "nurse_profile",
        //     "primary_specialty",
        //     data.primary_specialty, // ✅ FIX
        //   )
        // }
      />

      {/* <AdditionalSpecialtiesModal
        show={showAdditionalSpecialtiesModal}
        onHide={() => setShowAdditionalSpecialtiesModal(false)}
        value={formData.preferences.additional_specialties}
        isApplyPage={true}
        shouldUpdateProfile={
          !formData.preferences.additional_specialties ||
          formData.preferences.additional_specialties.length === 0
        }
        onSave={(value) =>
          handleInputChange("preferences", "additional_specialties", value)
        }
      /> */}
      <SalaryModal
        show={showSalaryModal}
        onHide={() => setShowSalaryModal(false)}
        value={formData.salary_preferences.preferred_salary} // ✅ FIXED
        isApplyPage={true}
        onSave={
          (value) =>
            handleInputChange("salary_preferences", "preferred_salary", value) // ✅ FIXED
        }
      />

      <YearsOfExperienceModal
        show={showExperienceModal}
        onHide={() => setShowExperienceModal(false)}
        selectedExperience={formData.nurse_profile.nursing_experience}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.nursing_experience}
        onSave={(exp) => {
          handleInputChange("nurse_profile", "nursing_experience", exp);
        }}
      />
      <RelocationModal
        show={showWillingToRelocateModal}
        onHide={() => setShowWillingToRelocateModal(false)}
        value={formData.nurse_profile.willing_to_relocate}
        shouldUpdateProfile={!formData.nurse_profile.willing_to_relocate}
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "willing_to_relocate", value)
        }
      />
      <PreferredStatesModal
        show={showPreferredStatesModal}
        onHide={() => setShowPreferredStatesModal(false)}
        value={formData.preferences.preferred_states}
        shouldUpdateProfile={
          !formData.preferences.preferred_states ||
          formData.preferences.preferred_states.length === 0
        }
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("preferences", "preferred_states", value)
        }
      />
      <CompactLicenseModal
        show={showHasCompactNursingLicenseModal}
        onHide={() => setShowHasCompactNursingLicenseModal(false)}
        value={formData.nurse_profile.has_compact_license}
        shouldUpdateProfile={
          formData.nurse_profile.has_compact_license === null ||
          formData.nurse_profile.has_compact_license === undefined
        }
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "has_compact_license", value)
        }
      />
      <PreferencesConfirmedModal
        show={showPreferencesConfirmedModal}
        onHide={() => setShowPreferencesConfirmedModal(false)}
        value={formData.nurse_profile.preferences_confirmed}
        shouldUpdateProfile={
          formData.nurse_profile.preferences_confirmed === null ||
          formData.nurse_profile.preferences_confirmed === undefined
        }
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "preferences_confirmed", value)
        }
      />
      <AvailabilitySetModal
        show={showAvailabilitySetModal}
        onHide={() => setShowAvailabilitySetModal(false)}
        value={formData.nurse_profile.availability_set}
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "availability_set", value)
        }
      />
      <ResumeUrlModal
        show={showResumeUrlModal}
        onHide={() => setShowResumeUrlModal(false)}
        value={formData.nurse_profile.resume_url}
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "resume_url", value)
        }
      />
      <ResUploadModal
        show={showResumeUploadedModal}
        onHide={() => setShowResumeUploadedModal(false)}
        value={formData.nurse_profile.resume_uploaded}
        file={formData.documents.resume?.[0] || null}
        isApplyPage={true}
        applicationId={id} // ⭐ VERY IMPORTANT
        shouldUpdateProfile={
          !formData.documents.resume || formData.documents.resume.length === 0
        }
        onSave={(value, file) => {
          handleInputChange("nurse_profile", "resume_uploaded", value);

          handleInputChange("documents", "resume", file ? [file] : []);
        }}
      />
      <CertsUploadedModal
        show={showCertsUploadedModal}
        onHide={() => setShowCertsUploadedModal(false)}
        value={formData.preferences.certs_uploaded}
        isApplyPage={true}
        shouldUpdateProfile={
          formData.nurse_profile.certs_uploaded === null ||
          formData.nurse_profile.certs_uploaded === undefined
        }
        onSave={(value) =>
          handleInputChange("nurse_profile", "certs_uploaded", value)
        }
      />
      <TraumaLevelExperienceModal
        show={showTraumaLevelExperienceModal}
        onHide={() => setShowTraumaLevelExperienceModal(false)}
        value={formData.nurse_profile.trauma_level_exp}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.trauma_level_exp}
        onSave={(value) =>
          handleInputChange("nurse_profile", "trauma_level_exp", value)
        }
      />
      <PatientPopulationModal
        show={showPatientPopulationModal}
        onHide={() => setShowPatientPopulationModal(false)}
        value={formData.nurse_profile.patient_population}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.patient_population}
        onSave={(value) =>
          handleInputChange("nurse_profile", "patient_population", value)
        }
      />
      <BedsideLast12MonthsModal
        show={showBedsideLast12MonthsModal}
        onHide={() => setShowBedsideLast12MonthsModal(false)}
        value={formData.nurse_profile.bedside_last_12mo}
        shouldUpdateProfile={
          formData.nurse_profile.bedside_last_12mo === null ||
          formData.nurse_profile.bedside_last_12mo === undefined
        }
        isApplyPage={true}
        onSave={(value) =>
          handleInputChange("nurse_profile", "bedside_last_12mo", value)
        }
      />
      <EducationModal
        show={showNursingEducationLevelModal}
        onHide={() => setShowNursingEducationLevelModal(false)}
        value={formData.nurse_profile.education}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.education}
        onSave={(value) =>
          handleInputChange("nurse_profile", "education", value)
        }
      />
      <AvailableToStartModal
        show={showAvailableToStartModal}
        onHide={() => setShowAvailableToStartModal(false)}
        value={formData.nurse_profile.available_to_start}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.available_to_start}
        onSave={(value) =>
          handleInputChange("nurse_profile", "available_to_start", value)
        }
      />
      <PrimarySpecialtyModal
        show={showPrimarySpecialtyModal}
        onHide={() => setShowPrimarySpecialtyModal(false)}
        value={formData.nurse_profile.primary_specialty}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.primary_specialty}
        onSave={(value) =>
          handleInputChange("nurse_profile", "primary_specialty", value)
        }
      />
      <LicenseVerifiedModal
        show={showIsLicenseHasBeenVerifiedModal}
        onHide={() => setShowIsLicenseHasBeenVerifiedModal(false)}
        value={formData.nurse_profile.license_verified}
        isApplyPage={true}
        shouldUpdateProfile={
          formData.nurse_profile.license_verified === null ||
          formData.nurse_profile.license_verified === undefined
        }
        onSave={(value) =>
          handleInputChange("nurse_profile", "license_verified", value)
        }
      />
      <LicenseNumberModal
        show={showLicenseNumberModal}
        onHide={() => setShowLicenseNumberModal(false)}
        value={formData.nurse_profile.license_number}
        isApplyPage={true}
        shouldUpdateProfile={!formData.nurse_profile.license_number}
        onSave={(value) =>
          handleInputChange("nurse_profile", "license_number", value)
        }
      />
    </div>
  );
};

export default ApplyJob;
